import { DOCUMENT } from '@angular/common';
import { UploadService } from './../../../_core/services/upload.service';
import { CadastroBensModalComponent } from '../cadastro-bens-modal/cadastro-bens-modal.component';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PageService } from './../../../_core/services/page.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { TipoDeBem } from 'src/app/_core/models/tipo-de-bem';
import Swal from 'sweetalert2';
import { CadastroBem } from 'src/app/_core/models/cadastro-bem';
import { CadastroBemService } from './../../../_core/services/cadastro-bem.service';
import { TipoDeBemService } from './../../../_core/services/tipo-de-bem.service';
import { Page } from 'src/app/_core/models/page';
import { HttpClient, HttpEvent, HttpEventType, HttpRequest } from '@angular/common/http';
import { environment as env } from 'src/environments/environment';
import { PermissaoService } from 'src/app/_core/services/permissao.service';
import { Permissao } from 'src/app/_core/models/permissao';
import { Usuario } from 'src/app/_core/models/usuario';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
@Component({
  selector: 'app-cadastro-bens',
  templateUrl: './cadastro-bens.component.html',
  styleUrls: ['./cadastro-bens.component.scss']
})
export class CadastroBensComponent implements OnInit {
@ViewChild('file') file: any;
form !: FormGroup;
tipoDeBem!:TipoDeBem[];
cadastroBem!:CadastroBem[];
myDate = new Date();
pagina = 1;
total = 10;
page!: Page;
ativo = true;
pesquisa = '';
loading = true;
cadastro !: CadastroBem;
public progress: number;
message:string;
DisabledButton = true;
permissao:Permissao[];
user: Usuario;


  constructor(
    private http:HttpClient,
    private tipoDeBemService:TipoDeBemService,
    private cadastroBemService:CadastroBemService,
    private uploadService:UploadService,
    private route: ActivatedRoute,
    private router:Router,
    private pageService:PageService,
    private permissaoService: PermissaoService,
    private modalService:NgbModal,
    @Inject(DOCUMENT) private document: Document) { 
    }

  ngOnInit(){
    this.ativo = true;
    this.user = JSON.parse(localStorage.getItem('currentUser') || '{}');
    //console.log/"Cargo obrigatorio", this.DisabledButton);
    this.getAcessoPermissao();
    this.page = new Page();
    this.page.currentPage = this.pagina;
    this.page.pageSize = this.total;
    this.page.ativo = this.ativo;
    this.page.currentPage = 1;
    this.setPage(this.page.currentPage);
    this.listarTipoDeBensAll();
    this.listarBensAll();
    this.progress = 0;

    
    
  }
  getAcessoPermissao() {
    //console.log/this.user);
    this.permissaoService.getBy_SiglaMatricula('PATRIMONIO', this.user.cD_MATRICULA).subscribe(
      (data:any) => {
        //console.log/"", data);
        this.permissao = data;
        // this.permissao.filter(index =>{
        //   return index.toString().indexOf('admin');
        // })
        // let index = this.permissao.findIndex(x => x.DS_PERFIL_ACESSO == 'contabilidade[EPATRIMONIO]')
        let index = this.permissao.map(function (e) { return e.DS_PERFIL_ACESSO.indexOf('contabilidade'); });
        //console.log/"Cargo " + index);
        if (index[0] == 0) {
          //console.log/"Cargo obrigatorio", this.DisabledButton);
          this.DisabledButton = false;
        }
        //console.log/"Cargo obrigatorio", this.DisabledButton);
      
      }
    )
  };
  refresh() {
    this.document.location.reload();
  }
  setPage(page:number){
    this.loading = true;
    this.page.currentPage = page;
    this.cadastroBemService.listarPage(this.page)
    .subscribe(
      data => {
        this.page = data;
        this.page = this.pageService.getPager(this.page);
        this.loading = false;
        
      },
      err => {
        this.loading = false;
      })
  }
  paginaAtual(pagina:any) {
    return this.page.currentPage === pagina;
  }
  pesquisar() {
    this.page.pesquisa = this.pesquisa;
    this.page.ativo = this.ativo;
    this.page.dados = [];
    this.setPage(this.page.currentPage);
  }
  atualizar() {
    this.pesquisa = '';
    this.ativo = true;
    this.page.dados = [];
    this.pesquisar();
  }
  listarTipoDeBensAll(){
    this.tipoDeBemService.listarTipoDeBensAll()
    .subscribe(
      data => {
        this.tipoDeBem = data;
      }
    )
  }

  listarBensAll(){
    this.cadastroBemService.listarBensAll().subscribe(
      data => {
        this.cadastroBem = data;
      }
    )
  }
  uploadPlanilha(files:any){
    //console.log/files);
    if (files.length === 0){
      
      return;
    }


    const formData = new FormData();

    formData.append("file", files[0]);
    this.progress = 0;
  this.cadastroBemService.uploadPlanilha(formData).subscribe(
    (event:HttpEvent<any>) => {
      
      if (event.type === HttpEventType.UploadProgress) {
        const percentual = Math.round((100 * event.loaded) / (event.total || 0));
        //console.log/'Carregando ', percentual)
        this.progress = percentual - 50;
        
      } else if (event.type === HttpEventType.Response) {
        this.progress = 100;
        this.message = event.body.message;
        Swal.fire(
          'Sucesso!',
          this.message,
          'success'
        ).then(() => {
          this.atualizar();
        });
      };
        
    });
  }


  delete(nR_BPM_BEM_PATRIMONIAL:number) {
    
    Swal.fire({
      title: 'Deseja deletar esse Bem?',
      confirmButtonText: 'Deletar',
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      icon: 'info',
    }).then((result)=>{
      if(result.value){
        this.cadastroBemService.delete(nR_BPM_BEM_PATRIMONIAL).
        subscribe(
          data => {
            const msg:string = 'O bem foi deletado com sucesso!'
            Swal.fire(
              'Sucesso!',
              msg,
              'success'
            ).then(() => {
              this.atualizar();
            });
          },
          err => {
            ////console.log/JSON.stringify(err))
            let msg:string = 'Erro ao deletar,tente novamente mais tarde!'
            if(err.status == 401){
              return msg = err.error.errors.join('  ');
            }
            Swal.fire('Erro',msg,'error').then(()=>{
              this.loading = false;
            });
          }
        )
      }
    })
  }
  abreEdicao(nR_BPM_BEM_PATRIMONIAL:any){
    const modalRef = this.modalService.open(CadastroBensModalComponent, {
      size: 'lg',
      backdrop: 'static',
      centered:true
    });
    modalRef.componentInstance.nR_BPM_BEM_PATRIMONIAL = nR_BPM_BEM_PATRIMONIAL
    modalRef.result.then(() =>{
      this.atualizar();
    });

  }

}